import React from 'react';
import { X } from 'lucide-react';

export default function YouTubeModal({ videoId, onClose }) {
  if (!videoId) return null;
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/92 backdrop-blur-sm" onClick={onClose}>
      <button onClick={onClose} className="absolute top-5 right-5 z-10 w-10 h-10 rounded-full bg-white/10 flex items-center justify-center active:scale-90 transition-transform">
        <X size={22} className="text-white" />
      </button>
      <div className="w-full max-w-[440px] px-3" onClick={(e) => e.stopPropagation()}>
        <div className="w-full aspect-video rounded-xl overflow-hidden ring-1 ring-white/10 bg-black">
          <iframe
            className="w-full h-full"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}
